import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactoControllerService, ContactoDTO, PoseedorControllerService, PoseedorDTO } from 'api-rest';
import { HoldersContactDialogComponent } from '../holders-contact-dialog/holders-contact-dialog.component';
import swal from 'sweetalert2'
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'lib-holders-detail-contact-data',
  templateUrl: './holders-detail-contact-data.component.html',
  styleUrls: ['./holders-detail-contact-data.component.scss']
})
export class HoldersDetailContactDataComponent implements OnChanges {
  @Input() poseedorInfo!: PoseedorDTO;
  @Output() public refrescarPoseedorEvent = new EventEmitter<any>();
  contactos: ContactoDTO[] = [];

  gridArray: any[] = [];

  headArray: any = [
    {
      Head: 'Requerido',
      FieldName: 'requerido',
      check: true,
      disabled: true
    },
    {
      Head: 'Tipo contacto',
      FieldName: 'tipo_contacto',
      Attribute: 'descripcionCorta',
      Tooltip: true
    },
    {
      Head: 'Tipo entidad',
      renderValue: (value: any) => value.persona ? 'Persona' : 'Empresa'
    },
    {
      Head: 'Nombre/Razón Social',
      FieldName: 'fullName',
      Tooltip: true
    },
    {
      Head: 'Activo',
      FieldName: 'obsoleto',
      renderValue: (item: any) => (item.obsoleto ? 'NO' : 'SI'),
    },
    {
      Head: 'Email',
      FieldName: 'email',
      Tooltip: true
    },
    {
      'Head': 'Acciones', 'FieldName': 'actions', 'buttons':
        [
          { 'nameButton': "view", "icon": "open_in_new", 'toolTip': 'Detalle', 'show': { 'params': 'canAccessView', 'accion': 'view' } },
          { 'nameButton': "delete", "icon": "delete", 'toolTip': 'Borrar', 'show': { 'params': 'canAccessDelete', 'accion': 'delete' }  },
          {
            nameButton: 'menu',
            array: [
              {
                nameButton: 'activate',
                name: 'Activar',
                show: { params: 'canAccessActivate', accion: 'activate' },
              },
              {
                nameButton: 'obsolete',
                name: 'Marcar como obsoleto',
                show: { params: 'canAccessObsolete', accion: 'obsolete' },
              }
            ],
          },
        ], 'width': '8', permanent: true
    },
  ];

  constructor(public dialog: MatDialog,
    private spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    @Inject('EmpusaAuthenticationService') private authService: EmpusaAuthenticationService,
    private contactoControllerSrv: ContactoControllerService,
    private poseedorControllerSrv: PoseedorControllerService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.poseedorInfo?.contactos) {
      this.contactos = this.poseedorInfo?.contactos;
      //TODO aplicar permisos
      this.gridArray = this.canAccessAll(this.contactos);

    }
  }

  canAccessAll(list: any) {
    const resultListShow = this.authService.can('poseedores-contactos', 'access');
    const resultDelete = this.authService.can('poseedores-contactos', 'delete');

    const listPermission = list.map((objeto: any) => {


      const noRequerido =  (!objeto.requerido || objeto.requerido === null );
      const esActivo = !objeto.obsoleto;
      const estadoObsoleto = this.poseedorInfo?.estado?.id !== 5 && this.poseedorInfo?.estado?.id !== 8;
      return { ...objeto,
        canAccessView: resultListShow,
        //canAccessListEdit: resultListEdit,
        canAccessDelete:
          resultDelete && noRequerido && this.poseedorInfo?.estado?.id !== 5 && this.poseedorInfo?.estado?.id !== 8,
        canAccessObsolete: esActivo && estadoObsoleto,
        canAccessActivate: !esActivo };

    });

    return listPermission;
  }
  action(item: any) {
    if (item.nameButton == 'view') {
      this.abrirModalContacto(item);
    } else if (item.nameButton == 'delete') {
      this.confirmacionEliminar(item);
    } else if (item.nameButton == 'activate') {
      this.comprobarContactosActivos(item);
    } else if (item.nameButton == 'obsolete') {
      this.confirmacionMarcarObsoleto(item);
    }
  }
  confirmacionEliminar(element?: ContactoDTO): void {
    swal.fire({
      text: '¿Desea eliminar el contacto?',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarContacto(element);
      }

    });
  }
  eliminarContacto(element?: ContactoDTO) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.contactoControllerSrv.borrarContacto(element.id)
        .subscribe({
          next: response => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar('El contacto se ha eliminado correctamente', 'success');
            this.refrescarPoseedorEvent.emit(true);
          },
          error: err => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar('Ha ocurrido un error al eliminar el contacto', 'error');
          }
        });
    }
  }
  abrirModalContacto(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersContactDialogComponent,
      {
        width: '950px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          contacto: element,
          poseedor: this.poseedorInfo
        },
        disableClose: true
      }
    );
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.refrescarPoseedorEvent.emit(true);
        }
      }
    );
  }

  canAccessCreateContact(): boolean {
    return (
      this.authService.can('poseedores-contactos', 'create') &&
      this.poseedorInfo?.estado?.id !== 5 &&
      this.poseedorInfo?.estado?.id !== 8
    );
  }

  comprobarContactosActivos(element?: ContactoDTO): void {
    //Si el contacto es de tipo Firmante o Rep Autorizado, solo puede hacer uno activo de cada tipo (incluyendo Empresa/Persona en caso de Rep Autorizado)
    if (element?.tipo_contacto?.id == 3 || element?.tipo_contacto?.id == 4) {
      let contactoExistente: any = null;
      if (element?.tipo_contacto?.id == 3) {
        contactoExistente = this.contactos?.filter((pContacto: any) => !pContacto.obsoleto && pContacto.tipo_contacto.id == element?.tipo_contacto?.id)[0];
      } else {
        contactoExistente = this.contactos?.filter((pContacto: any) => !pContacto.obsoleto && pContacto.tipo_contacto.id == element?.tipo_contacto?.id && pContacto.persona == element?.persona)[0];
      }
      if (contactoExistente) {
        swal.fire({
          text: `No está permitido activar otro contacto de tipo Firmante o Representante autorizado puesto que ya existe uno activo. ¿Quiere marcar el contacto existente como obsoleto?`,
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Sí',
          denyButtonText: 'No',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.activarContacto(element, contactoExistente);
          }
        });
      } else {
        this.activarContacto(element);
      }
    } else {
      this.activarContacto(element);
    }
  }

  activarContacto(element?: any, contactoExistente?: any) {
    if (element?.id) {
      if (contactoExistente) {
        contactoExistente.obsoleto = true;
        const pContacto: any = this.poseedorInfo?.contactos?.filter((item: any) => item.id == element.id)[0];
        pContacto.obsoleto = false;
        this.spinnerSrv.loadingShow();
        this.poseedorControllerSrv
          .editById3(this.poseedorInfo.id!, this.poseedorInfo as any)
          .subscribe({
            next: (response) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'El contacto se ha activado correctamente',
                'success'
              );
              this.refrescarPoseedorEvent.emit(true);
            },
            error: (err) => {
              this.spinnerSrv.loadingHide();
              this.snackBarSrv.showSnackBar(
                'Ha ocurrido un error al activar el contacto',
                'error'
              );
              console.log(err);
            },
          });
      } else {
        element.obsoleto = false;
        this.spinnerSrv.loadingShow();
        this.contactoControllerSrv.actualizarContacto(element.id, element).subscribe({
          next: (response) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'El contacto se ha activado correctamente',
              'success'
            );
            this.refrescarPoseedorEvent.emit(true);
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al activar el contacto',
              'error'
            );
            console.log(err);
          },
        });
      }
    }
  }

  confirmacionMarcarObsoleto(element?: ContactoDTO): void {
    swal
      .fire({
        text: '¿Desea marcar el contacto como obsoleto?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.marcarContactoObsoleto(element);
        }
      });
  }

  marcarContactoObsoleto(element?: any) {
    if (element?.id) {
      element.obsoleto = true;
      this.spinnerSrv.loadingShow();
      this.contactoControllerSrv.actualizarContacto(element.id, element).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El contacto se ha marcado como obsoleto',
            'success'
          );
          this.refrescarPoseedorEvent.emit(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al marcar el contacto como obsoleto',
            'error'
          );
          console.log(err);
        },
      });
    }
  }
}
